import React from "react";
import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import PrivacyPolicy from "../components/PrivacyPolicy";
import { Helmet } from "react-helmet-async";

const PrivacyPolicyPage = () => {



  return (
    <>

      <Helmet>
        <title> Privacy Policy | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Privacy Policy"} />

      {/* Account */}
      <PrivacyPolicy />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  );
};

export default PrivacyPolicyPage;
